import { Tab, Tabs } from '@mui/material';
import { useIsTechnician } from 'shared/permissions/useIsTechnician';
import { TenantPage } from 'layouts';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { metabaseDashboardService } from 'shared/services';
import { IMetbaseDashboard } from './types';

interface Props {
  category?: string;
}

function ReportList(props: Props) {
  const { category } = props;
  // Il tecnico vede solo la vista Rendicontazione (reporting), non custom-reports né i tab Metabase.
  const technicianBlocked = useIsTechnician() && category;
  const [dashboards, setDashboards] = useState<IMetbaseDashboard[]>([]);
  const [value, setValue] = useState<number | string>();
  const navigate = useNavigate();

  useEffect(() => {
    if (technicianBlocked) {
      setDashboards([]);
      return;
    }
    metabaseDashboardService
      .getAllPaginated(100, 0, {
        category: category ?? 'DEFAULT_CONTEXT'
      })
      .then(setDashboards);
  }, [category, technicianBlocked]);

  useEffect(() => {
    if (value) {
      navigate(`${value}`);
    }
  }, [value, navigate]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(+newValue);
  };

  return (
    <TenantPage title="" subtitle="">
      <Tabs
        sx={{ overflow: 'scroll', maxWidth: 'calc(100vw - 300px)' }}
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        variant="scrollable"
        aria-label="secondary tabs example">
        {dashboards.map((dashboard) => (
          <Tab key={dashboard.id} value={dashboard.id} label={dashboard.title}></Tab>
        ))}
      </Tabs>
      <Outlet />
    </TenantPage>
  );
}

export default ReportList;
